import { styled } from '@mui/material';

export const InputW = styled('div')`
  &.personalData {
    width: 100%;
    max-width: 100%;
  }
  @media (max-width: 1023px) {
    width: 100%;
    &.personalData {
      max-width: 100%;
    }
  }
`;
